import { MIN_TEMPLATE_ID } from '../../components/global/_constants';

/**
 * Returns true if the provided templateId is valid (greater than or equal to MIN_TEMPLATE_ID).
 * Does not check if the templateId actually exists.
 * @param templateId template ID to validate
 * @returns boolean indicating if the templateId is valid
 */
export const isValidTemplateId = (templateId: number | undefined): boolean => {
  return templateId !== undefined && templateId >= MIN_TEMPLATE_ID;
};
